import * as React from 'react';
import * as AOIModule from 'Modules/AOIModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as MapModule from 'Modules/MapModule';
import { copy, arraysEqual } from './MapHelpers';
import { Marker, Polygon } from 'react-leaflet';
import { connect } from 'react-redux';
import * as L from 'leaflet';

type ManageablePolygonP = {
    positions: Array<Array<Array<L.LatLngExpression>>>;
    setActiveAoi?: Function;
    zoneData: AOIModule.Types.AreaOfInterestDto;
    active: boolean;
    aoiStore?: AOIModule.Types.AOIStore;
    viewManagementStore?: ViewManagementModule.Types.ViewManagementStore;
    showAoiDetailsPopup?: Function;
    hideAoiDetailsPopup?: Function;
    setMapCenter: Function;
    exportPositions: (positions: Array<Array<Array<L.LatLngExpression>>>) => void;
};
type ManageablePolygonS = {
    editablePositions: Array<L.LatLngExpression>;
    polygonPositions: Array<Array<Array<L.LatLngExpression>>>;
};
class ManageablePolygonR extends React.Component<ManageablePolygonP, ManageablePolygonS> {
    private initialValues: Array<Array<Array<L.LatLngExpression>>> = this.getInitialPolygonPositions(copy(this.props.positions));
    constructor(props: ManageablePolygonP) {
        super(props);
        this.state = {
            editablePositions: [...this.props.positions][0][0],
            polygonPositions: []
        };
        this.manageMarkerDrag = this.manageMarkerDrag.bind(this);
        this.getInitialPolygonPositions = this.getInitialPolygonPositions.bind(this);
        this.polygonClick = this.polygonClick.bind(this);
    }
    private manageMarkerDrag(event: L.DragEndEvent, currentIdx: number) {
        const currentState = [...this.state.editablePositions];
        const latlng = event.target._latlng;
        currentState[currentIdx] = [latlng.lat, latlng.lng];
        const polygonPositions = [...this.props.positions];
        polygonPositions[0][0] = currentState;
        this.setState({
            editablePositions: currentState,
            polygonPositions
        });
        this.props.exportPositions(polygonPositions);
    }

    public shouldComponentUpdate(nextProps) {
        if (this.props.active === true && nextProps.active === false) {
            this.setState({
                polygonPositions: this.initialValues,
                editablePositions: this.initialValues[0][0]
            });
        }
        return true;
    }
    public componentDidMount() {
        const polygonPositions = this.getInitialPolygonPositions([...this.props.positions]);
        this.setState({
            polygonPositions
        });
        this.props.exportPositions(copy(polygonPositions));
    }

    private getInitialPolygonPositions(pos: Array<Array<Array<L.LatLngExpression>>>) {
        const posClone = [...pos];
        const areEqual = arraysEqual(posClone[0][0][0], posClone[0][0][posClone[0][0].length - 1]);
        if (areEqual) {
            posClone[0][0].pop();
        }
        return posClone;
    }
    private polygonClick() {
        const { setActiveAoi, zoneData, showAoiDetailsPopup, hideAoiDetailsPopup, setMapCenter } = this.props;
        const center = { lat: zoneData.multipolygonGeoJson.coordinates[0][0][0][0], lng: zoneData.multipolygonGeoJson.coordinates[0][0][0][1] };
        setActiveAoi(zoneData);
        setMapCenter(center);
        hideAoiDetailsPopup();
        showAoiDetailsPopup();
    }
    public render() {
        const { editablePositions, polygonPositions } = this.state;
        const { active, viewManagementStore } = this.props;
        const icon = L.divIcon({
            iconUrl: '/images/icons/poi_marker.svg',
            iconSize: [15, 15],
            html: `<div class="dot-icon dot-icon--blue"></div>`,
            className: `dots `
        });

        return (
            <>
                {active ? (
                    <>
                        <Polygon className={`zone zone--active`} positions={polygonPositions} onClick={() => this.polygonClick()} />
                        <Polygon className={`zone`} positions={this.initialValues} onClick={() => this.polygonClick()} />
                    </>
                ) : (
                    <Polygon className={`zone`} positions={this.initialValues} onClick={() => this.polygonClick()} />
                )}

                {active &&
                    !viewManagementStore.activeAddingAOI &&
                    editablePositions.map((editableMarkerPos, idx) => {
                        return <Marker key={`${idx}-editable`} position={editableMarkerPos} icon={icon} draggable onDragEnd={event => this.manageMarkerDrag(event, idx)} />;
                    })}
            </>
        );
    }
}
function mapStateToProps(state: any) {
    return {
        aoiStore: state.aoiStore,
        viewManagementStore: state.viewManagementStore
    };
}
function mapDispachToProps(dispatch: any) {
    return {
        setActiveAoi: (aoiDetails: AOIModule.Types.AreaOfInterestDto) => dispatch(AOIModule.Actions.setDetailsForAoiView(aoiDetails)),
        showAoiDetailsPopup: () => dispatch(AOIModule.Actions.showAoiDetailsPopup()),
        hideAoiDetailsPopup: () => dispatch(AOIModule.Actions.hideAoiDetailsPopup()),
        setMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.setMapCenter(center))
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(ManageablePolygonR);



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/ManageablePolygon.tsx